import { Loading } from "../../components/Loading/loading";
import { MouseEvent } from "react";
import { RiNextjsFill, RiSupabaseFill } from "react-icons/ri";
import { FaSalesforce, FaSass } from "react-icons/fa";
import { FaLinkedinIn, FaEnvelope } from "react-icons/fa6";
import { useLanguage } from "../../i18n/LanguageContext";

import "./home.css";

const primarySkills = [
  { name: "Salesforce", Icon: FaSalesforce },
  { name: "Next.js", Icon: RiNextjsFill },
  { name: "Sass", Icon: FaSass },
  { name: "Supabase", Icon: RiSupabaseFill },
];

export const Home = () => {
  const { t } = useLanguage();

  const scrollToProjects = (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    const projectsSection = document.querySelector("#proyectos");
    projectsSection?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <>
      <Loading />
      <main className="home-page">
        <section className="home-shell">
          <header className="hero-section">
            <p className="hero-kicker">{t("home.hero.kicker")}</p>
            <h1>
              {t("home.hero.titleMain")}
            </h1>
            <p className="hero-description">{t("home.hero.description")}</p>
            <div className="hero-actions">
              <a href="mailto:jeancarlosayala57@gmail.com">
                {t("home.hero.sayHello")}
              </a>
              <a href="#proyectos" onClick={scrollToProjects}>
                {t("home.hero.viewProjects")}
              </a>
            </div>
            <ul className="hero-meta">
              <li>{t("home.hero.available")}</li>
              <li>{t("home.hero.location")}</li>
            </ul>
          </header>

          <aside className="contact-panel">
            <p className="panel-label">{t("home.contact.label")}</p>
            <a href="mailto:jeancarlosayala57@gmail.com">
              jeancarlosayala57@gmail.com
            </a>
            <p>{t("home.contact.pitch")}</p>
            <a href="#proyectos" onClick={scrollToProjects}>
              {t("home.contact.explore")}
            </a>
            <div className="social-links" aria-label={t("home.contact.linksLabel")}>
              <a
                href="https://www.linkedin.com/in/jean-ayala/"
                target="_blank"
                rel="noreferrer"
                aria-label="LinkedIn"
              >
                {FaLinkedinIn({ "aria-hidden": true })}
              </a>
              <a
                href="mailto:jeancarlosayala57@gmail.com"
                aria-label="Email"
              >
                {FaEnvelope({ "aria-hidden": true })}
              </a>
            </div>
          </aside>
        </section>

        <section id="proyectos" className="featured-work">
          <div className="section-heading">
            <p>{t("home.featured.kicker")}</p>
            <h2>{t("home.featured.title")}</h2>
          </div>

          <div className="work-grid">
            <article className="work-card">
              <p>01</p>
              <h3>Creepymosh</h3>
              <span>{t("home.projects.creepymosh.description")}</span>
              <a
                className="work-link"
                href="https://creepymosh.com"
                target="_blank"
                rel="noreferrer"
              >
                creepymosh.com
              </a>
            </article>
            <article className="work-card">
              <p>02</p>
              <h3>Pinned</h3>
              <span>{t("home.projects.pinned.description")}</span>
              <a
                className="work-link"
                href="https://pinn-ed.com"
                target="_blank"
                rel="noreferrer"
              >
                pinn-ed.com
              </a>
            </article>
          </div>
        </section>

        <section className="journey-section">
          <div className="section-heading">
            <p>{t("home.journey.kicker")}</p>
            <h2>{t("home.journey.title")}</h2>
          </div>

          <div className="journey-grid">
            <article className="journey-card">
              <p className="journey-year">2019</p>
              <h3>{t("home.journey.firstTitle")}</h3>
              <p>{t("home.journey.firstDescription")}</p>
            </article>

            <article className="journey-card">
              <p className="journey-year">2020</p>
              <h3>{t("home.journey.secondTitle")}</h3>
              <p>{t("home.journey.secondDescription")}</p>
            </article>
          </div>
        </section>

        <section className="stack-section">
          <div className="section-heading">
            <p>{t("home.stack.kicker")}</p>
            <h2>{t("home.stack.title")}</h2>
          </div>
          <section className="skills-grid">
            {primarySkills.map((skill, idx) => (
              <article className="skill-card" key={`${skill.name}-${idx}`}>
                {skill.Icon({ className: "skill-card-icon", "aria-hidden": true })}
                <span>{skill.name}</span>
              </article>
            ))}
          </section>
        </section>

        <footer className="home-cta">
          <h2>{t("home.cta.title")}</h2>
          <p>{t("home.cta.description")}</p>
          <a className="email" href="mailto:jeancarlosayala57@gmail.com">
            jeancarlosayala57@gmail.com
          </a>
        </footer>
      </main>
    </>
  );
};
